import axios from "axios";

export const appAxios = axios.create({
  baseURL: "https://api.hedefly.com/api/",
  // baseURL: "http://127.0.0.1:8000/api/",
});

// axios.defaults.baseURL = "https://aho-api-render.onrender.com/api";
